import './DeparturesHeader.scss';

import Add from '@mui/icons-material/Add';
import Description from '@mui/icons-material/Description';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { openDrawer } from '../../../slices/drawerSlice';

import { LargeTitle } from '../../../common-components/Titles/Titles';
import { Button } from '../../../common-components/Buttons/Buttons';

import DeparturesReportCreate from '../DeparturesReportCreate/DeparturesReportCreate';
import DeparturesReportCreateFooter from '../DeparturesReportCreate/components/DeparturesReportCreateFooter';

const DeparturesHeader = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.user.data);
    const role = data?.attributes?.role_id;

    const canAddReport = role === 'admin' || role === 'branch_office_user';

    const handleOpen = () => {
        dispatch(
            openDrawer({
                content: <DeparturesReportCreate />,
                footer: <DeparturesReportCreateFooter />,
            }),
        );
    };

    const handleOpenReportApp = () => {
        window.open('https://wa.resqcore.kz', '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="departures-header">
            <div className="departures-header_container">
                <div className="departures-header_title">
                    <LargeTitle property="Оперативные выезды" />
                </div>

                {canAddReport && (
                    <div className="departures-header_actions">
                        <Button
                            Icon={Description}
                            title="Сформировать сообщение"
                            onClick={handleOpenReportApp}
                        />

                        <Button Icon={Add} title="Добавить" onClick={handleOpen} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default DeparturesHeader;